import { CaracteristicaValor } from "./valor-caracteristica";

export class TipoCaracteristica {
    constructor(
        public IdTipoCaracteristica?: number | string,
        public descripcion?: string
    ) { }
}

export class Caracteristica {
    constructor(
        public IdCaracteristica?: number | string,
        public descripcion?: string,
        public valores: CaracteristicaValor[] = <CaracteristicaValor[]>[],
        public seleccionado: CaracteristicaValor = new CaracteristicaValor(),
        public tipoCaracteristica = new TipoCaracteristica(),
        public mostrarDescripcion: boolean = true,
        public ordenImpresion?: number
    ) { }
}

